import { mainBtnClassName } from '../../../constants';
import Icon from '../icon';

const getDisabledClassName = (className) => {
    const classes = String(className || '').trim().split(/\s+/).filter(Boolean);
    const disabledClasses = classes.map((name) => `${name}--disabled`);
    return [...classes, ...disabledClasses].join(' ');
};

export const Button = ({
    onClick,
    text,
    children,
    className = 'btn btn-continue',
    type = 'button',
    disabled = false,
    ariaLabel,
    ...rest
}) => {
    const btnClassName = disabled ? getDisabledClassName(className) : className;
    return (
        <button
            onClick={onClick}
            className={btnClassName}
            type={type}
            disabled={disabled}
            aria-label={ariaLabel}
            {...rest}
        >
            {children ?? text}
        </button>
    );
};

export const MainButton = (props) => (
    <Button className={mainBtnClassName} {...props} />
);

export const SecondaryButton = (props) => <Button {...props} />;

export const ButtonIcon = ({
    onClick,
    text,
    className = 'btn btn-search-mobile-clean',
    type = 'button',
    disabled = false,
    icon,
    fill,
}) => {
    const btnClassName = disabled ? getDisabledClassName(className) : className;
    return (
        <button
            onClick={onClick}
            className={btnClassName}
            type={type}
            disabled={disabled}
            style={{
                display: 'flex',
                justifyContent: 'space-evenly',
            }}
        >
            {text} <Icon name={icon} fill={fill} size={22} />
        </button>
    );
};
